@if (unitTypeList) {
  <p-select
    [appendTo]="'body'"
    (onChange)="onUnitTypeChange($event)"
    [options]="unitTypeList"
    [(ngModel)]="unitType"
    [filter]="false"
    [disabled]="disabled()"
    [placeholder]="unitType"
  >
  </p-select>
}
